import { AxiosRequest } from "../common/axios-request";
import {
  CREATE_SPORT,
  DELETE_SPORT,
  DELETE_SPORT_RULE,
  GET_ALL_SPORT_LIST,
  GET_SPORT_DETAILS,
  UPDATE_SPORT,
  GET_SPORT_OF_FACILITY,
  CREATE_SESSION,
} from "../common/constant";

const GetSportsDetails = (id: any) => {
  return AxiosRequest.get(GET_SPORT_DETAILS.replace(":id", id));
};

const GetSportsList = (payload: any) => {
  let { facilityId = "", isActive = "" } = payload
  return AxiosRequest.get(GET_ALL_SPORT_LIST(facilityId, isActive));
};

const CreateNewSport = (payload: any) => {
  return AxiosRequest.post(CREATE_SPORT, payload);
};

const UpdateSport = (id: string, payload: any) => {
  return AxiosRequest.put(UPDATE_SPORT.replace(":id", id), payload);
};

const DeleteSport = (id: string) => {
  return AxiosRequest.delete(DELETE_SPORT.replace(":id", id));
};

const DeleteSportRule = (id: string, rule: string) => {
  return AxiosRequest.delete(
    DELETE_SPORT_RULE.replace(":id", id).replace(":rule", rule)
  );
};

//session
const CreateNewSession = (payload: any) => {
  return AxiosRequest.post(CREATE_SESSION, payload);
};

const GetSportsForFacility = (id: string) => {
  return AxiosRequest.get(GET_SPORT_OF_FACILITY(id));
};

export {
  GetSportsList,
  CreateNewSport,
  GetSportsDetails,
  UpdateSport,
  DeleteSport,
  DeleteSportRule,
  CreateNewSession,
  GetSportsForFacility,
};
